/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskWorkflowItemConfiguration } from './TaskWorkflowItemConfiguration';
import {
    TaskWorkflowItemConfigurationFromJSON,
    TaskWorkflowItemConfigurationFromJSONTyped,
    TaskWorkflowItemConfigurationToJSON,
    TaskWorkflowItemConfigurationToJSONTyped,
} from './TaskWorkflowItemConfiguration';

/**
 * 
 * @export
 * @interface FindAllTaskWorkflowItemConfigurations200Response
 */
export interface FindAllTaskWorkflowItemConfigurations200Response {
    /**
     * 
     */
    data: Array<TaskWorkflowItemConfiguration>;
}

/**
 * Check if a given object implements the FindAllTaskWorkflowItemConfigurations200Response interface.
 */
export function instanceOfFindAllTaskWorkflowItemConfigurations200Response(value: object): value is FindAllTaskWorkflowItemConfigurations200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function FindAllTaskWorkflowItemConfigurations200ResponseFromJSON(json: any): FindAllTaskWorkflowItemConfigurations200Response {
    return FindAllTaskWorkflowItemConfigurations200ResponseFromJSONTyped(json, false);
}

export function FindAllTaskWorkflowItemConfigurations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllTaskWorkflowItemConfigurations200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TaskWorkflowItemConfigurationFromJSON)),
    };
}

export function FindAllTaskWorkflowItemConfigurations200ResponseToJSON(json: any): FindAllTaskWorkflowItemConfigurations200Response {
    return FindAllTaskWorkflowItemConfigurations200ResponseToJSONTyped(json, false);
}

export function FindAllTaskWorkflowItemConfigurations200ResponseToJSONTyped(value?: FindAllTaskWorkflowItemConfigurations200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(TaskWorkflowItemConfigurationToJSON)),
    };
}

